import React from "react";

import { css } from "@emotion/css";
import { useNavigate } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

import { useStyles } from "@/hooks/useStyles.ts";
import { Button } from "@/uiKit/atoms/Button.tsx";
import { Card } from "@/uiKit/atoms/Card.tsx";
import { CardContent } from "@/uiKit/atoms/CardContent.tsx";
import { CardHeader } from "@/uiKit/atoms/CardHeader.tsx";

export type AnteriorityCardProps = {
  className?: string;
};

export const AnteriorityCard: React.FC<AnteriorityCardProps> = ({ className }) => {
  const { t } = useTranslation();
  const styles = useStyles(makeStyles);

  const navigate = useNavigate();

  return (
    <Card id="anteriority-card" className={className}>
      <CardHeader id="anteriority-title" title={t("pages.search.title")} />
      <CardContent>
        <Button
          id="go-to-anterirority-search"
          data-action="account.anteriority.navigate"
          className={styles.button}
          variant="outlined"
          onClick={() => navigate({ to: "/search" })}
        >
          {t("pages.search.CTARedirectButton")}
        </Button>
      </CardContent>
    </Card>
  );
};

const makeStyles = () => ({
  button: css`
    width: fit-content;
  `,
});
